import paths from "./paths";

// export const appRoutes = {
//   label: 'Dashboard',
//   labelDisable: true,
//   children: [
//     {
//       name: 'Dashboard',
//       active: true,
//       icon: 'chart-pie',
//       to: rootPaths.root,
//       exact: true,
//     }
//   ]
// };

export const horusDashboardRoutes = {
  label: "Dashboard",
  labelDisable: true,
  children: [
    {
      name: "Dashboard",
      active: true,
      icon: "project-diagram",
      to: paths.horusDashboard,
    },
  ],
};

export const horusDatasetRoutes = {
  label: "Dataset",
  children: [
    {
      name: "Add",
      active: true,
      icon: "file-upload",
      to: paths.horusDatasetAdd,
    },
  ],
};

export const horusComputationRoutes = {
  label: "Computation",
  children: [
    {
      name: "Add",
      icon: "file-upload",
      to: paths.horusComputationAdd,
      active: true,
    },
    {
      name: "Charts & KPIs",
      icon: "chart-line",
      to: paths.horusComputationCharts,
      active: true,
    },
    {
      name: "Analysis",
      icon: "chart-pie",
      to: paths.horusComputationAnalysis,
      active: true,
    },
    {
      name: "Result",
      icon: "table",
      to: paths.horusComputationResult,
      active: true,
    },
  ],
};

export const horusControlRoutes = {
  label: "Control",
  children: [
    {
      name: "Charts & KPIs",
      icon: "chart-line",
      to: paths.horusControlCharts,
      active: true,
    },
    {
      name: "Analysis",
      icon: "chart-pie",
      to: paths.horusControlAnalysis,
      active: true,
    },
    {
      name: "Result",
      icon: "table",
      to: paths.horusControlResult,
      active: true,
    },
  ],
};

export const horusVariationAnalysisRoutes = {
  label: "Variation Analysis",
  children: [
    {
      name: "Add",
      icon: "file-upload",
      to: paths.horusVariationAnalysisAdd,
      active: true,
    },
    {
      name: "Charts & KPIs",
      icon: "chart-line",
      to: paths.horusVariationAnalysisCharts,
      active: true,
    },
    {
      name: "Analysis",
      icon: "chart-pie",
      to: paths.horusVariationAnalysisAnalysis,
      active: true,
    },
    {
      name: "Result",
      icon: "table",
      to: paths.horusVariationAnalysisResult,
      active: true,
    },
  ],
};

export default [
  horusDashboardRoutes,
  horusDatasetRoutes,
  horusComputationRoutes,
  horusControlRoutes,
  horusVariationAnalysisRoutes,
];
